"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFY_ME_BUTTON = void 0;
const NOTIFY_ME_BUTTON = exports.NOTIFY_ME_BUTTON = 'notify-me-button';
